<template>
  <div>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text"> {{ 'Tur Alt Paketler' }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="deleteMasterTur()"> {{ $t('Delete') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-form ref="formmasterpaket" v-model="validmasterpaket" lazy-validation>
                      <v-layout wrap>
                         <v-flex xs12 sm12 md12>
                          <tarihim :etiket="$t('Date')" 
                                v-model="eklenecektarih" style="width: 100%;"
                               ></tarihim>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>
             <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
              </v-btn>
           
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="pakettenPaketKopyalaDialog" persistent max-width="500px">
        <v-card color="grey lighten-5" style="height: 500px;">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Paket Kopyala</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-form ref="formmasterpaket" v-model="validmasterpaket" lazy-validation>
                      <v-layout wrap>
                         <v-flex xs12 sm12 md12>
                          <label>Tarihler Seçiniz</label>
                          <m-date-picker lang="tr" :disp="disp" v-model="dateList" :multi="true" :always-display="false" :format="formatDate"></m-date-picker>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="blue darken-1" flat @click="vazgecPakettenPaket()">{{$t('Cancel')}}</v-btn>
             <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="pakettenPaketKopyala()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
              </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{'Paket Tur Alt Paketler'}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>
        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="yeniekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{'Alt Paket Ekle'}} </span>
            </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save"> {{ $t('Add-v2', { value: 'Master-Tur'}) }}</span>
        </v-tooltip>
      </v-toolbar>
    </v-layout>
    <v-card color="grey lighten-5" flat>  
      <v-flex xs12 sm12 md12>
        <v-form ref="formgunluksatis" lazy-validation>
          <v-card flat class="pa-3">
            <v-layout row>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4>
                    <v-select
                            label="Master Paket Seçin"
                            v-model="selectedmasterid"
                            item-text="TurAdi"
                            item-value="Id"
                            :items="masteritems"
                          ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-layout>
                      <v-btn color="info" @click="getlist()"  fab small dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm0 md1>
                                </v-flex>     
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-form>
      </v-flex>
    </v-card>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="altpaketitems"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.TurKodu }}</td>
            <td class="text-xs-left">{{ props.item.TurAdi }}</td>
            <td class="text-xs-left">{{ props.item.BaslangicNoktasi }}</td>
            <td class="text-xs-left">{{ props.item.VarisParkur }}</td>
            <td class="text-xs-left">{{ props.item.DonusParkur }}</td>
            <td class="text-xs-left">{{ formatDate(props.item.BaslangicTarihi) }}</td>
            <td class="text-xs-left">{{ formatDate(props.item.BitisTarihi) }}</td>
            <td class="text-xs-left">{{ props.item.Kategori.isim }}</td>
            <td class="text-xs-left">{{ props.item.UrunGrubu.isim }}</td>
            <td class="text-xs-left">{{ props.item.Gunduz }}</td>
            <td class="text-xs-left">{{ props.item.Gece }}</td>
            <td class="text-xs-left">{{ props.item.Kontenjan }}</td>
            <td class="text-xs-left">{{ props.item.KalanKontenjan }}</td>
            <td class="text-xs-left">{{ props.item.Notlar }}</td>
            <td class="text-xs-right">
                      <v-btn
                        color="info"
                        @click="gitUpdate(props.item)"
                        icon small flat
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                      <v-btn
                        color="info"
                        @click="openPakettenPaketKopyalaDialog(props.item.Id)"
                        icon small flat
                      >
                        <v-icon>note</v-icon>
                      </v-btn>
                      <v-btn  @click="" icon small flat>
                <v-icon color="warning"  @click="deleteDialogOpen(props.item)">delete</v-icon>
              </v-btn>
                    </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import tool from "../coper/tools";
  import tarihim from "@/components/app/customcomp/tarihim.vue"
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

  export default {
    data() {
      return {
        insertid:null,
        tmpalttur:null,
        deleteDialog: false,
        text1: null,
        
        deleteId:0,
        validbanka: true,
        passwordRules: [
          v => !!v || this.$t('This-space-cannot-left-blank'),
          v => (v && v.length < 5) || this.$t('Maximum-4-characters')
        ],
        sayfayetki: {
          Screen: true,
          Update: true,
          Save: true,
          Delete: true,
          Status: true,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: 'Tur Kodu',
            
          },
          {
            text: 'Tur Adı',
            value: 'TurAdi'
          },
          {
            text: 'Başlangıç Noktası',
            value: 'BaslangicNoktasi'
          },
          {
            text: 'Varış Parkur',
            value: 'VarisParkur'
          },
          {
            text: 'Dönüş Parkur',
            value: 'DonusParkur'
          },
          {
            text: 'Başlangıç Tarihi',
            value: 'BaslangicTarihi'
          },
          {
            text: 'Bitiş Tarihi',
            value: 'BitisTarihi'
          },
          {
            text: 'Ürün Grubu',
            value: 'UrunGurubuAdi'
          },
          {
            text: 'Kategori',
            value: 'KategoriAdi'
          },
          {
            text: 'Gündüz',
            value: 'Gunduz'
          },
          {
            text: 'Gece',
            value: 'Gee'
          },
          {
            text: 'Kontenjan',
            value: 'Kontenjan'
          },
          {
            text: 'Kalan Kontenjan',
            value: 'KalanKontenjan'
          },
          {
            text: 'Notlar',
            value: 'Notlar'
          },
          {
            text: 'İşlem',
          
          }

        ],
        loading: false,
        color: 'orange darken-4',
        disp:["Pzt","Salı","Çar","Per","Cum","Cmt","Paz"],
        search3: '',
        search: null,
        select: [],
        selected: '',
        masteritems: [],
        selectedmasterid:null,
        altpaketitems:[],
        eklenecektarih:null,
        m: false,
        k: false,
        dialog: false,
        dateList:[],
        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        pakettenPaketKopyalaDialog:false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => this.$t('This-space-cannot-left-blank'),
              max: () => this.$t('Must-least-4-digits'),
            },
            bankaadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
      search3: function(val){
        console.log(val)
        if(val.length > 3){
          this.paketSearch(val);
        }
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.MasterTurList();
    },
    methods: {
      deleteDialogOpen(val) {
      this.deleteDialog = true;
      this.deleteId = val.Id;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("tr-TR", {
        day: "numeric", // Günü gösterir
        month: "long",  // Ay adını gösterir (örnek: Aralık)
        year:"numeric",
      });
    },
    pakettenPaketKopyala(){
    let paramscopy = {
    PaketId: this.pakettenPaketKopyalaId,
    Tarihler: this.dateList,
    tumSirketler: false,
    sayfaAdi: null,
  };
    tool.http_post(this, "PakettenPaketKopyala", paramscopy).then(
    (response) => {
      if (response.body.Status == true) {
        this.getlist();
        this.pakettenPaketKopyalaDialog = false;
        this.text1 = 'Kayıt Başarılı';
        this.snackbar = true;
      }});
  },
      openPakettenPaketKopyalaDialog(val){
        this.pakettenPaketKopyalaDialog = true;
        this.pakettenPaketKopyalaId = val;
      },
    deleteMasterTur(id)
    {
      let params = {
        Id: this.deleteId,
      };
      tool.http_post(this, "PaketDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getlist();
           this.deleteDialog=false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },
      gitUpdate(val)
      {
        var url = '#/pakettur/turaltpaketislem/islem?id=' +  val.Id;
        window.open(url, '_self')
      },
      yeniekle() {
        if (this.selectedmasterid==null)
      {
        return;
      }
      this.dialog_baslik='Yeni Alt Paket';
           this.dialog=true;
        },
        getlist()
        {
          let params = {
          MasterTurId: this.selectedmasterid,
          tumSirketler: false,
          sayfaAdi: null,
        };
      tool.http_post(this, "MasterTurAltPaketList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.altpaketitems=response.body.data;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
    },
    (response) => {
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
    }
  );

        },
        MasterTurList() {
          this.loadingvmodel=true;
      let params = {
        Ref: 0,
        TurKodu: null,
        TurAdi: null,
        Notlar: null,
        Gece: 0,
        Gunduz: 0,
        Aktif: false,
        KategoriId: 0,
        UrunGrubuId: 0,
        Kontenjan: 0,
        KayitTarihi: "2020-01-01T00:00:00",
        tumSirketler: false,
        sayfaAdi: null,
      };
      tool.http_post(this, "MasterTurList", params).then(
        (response) => {
          if (response.body.Status == true) {
           
            this.masteritems=response.body.data;
            this.loadingvmodel=false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel=false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.loadingvmodel=false;
        }
      );
    },
    paketSearch(search){
      var params = {
        SearchTerm:search
      }
      tool.http_post(this, "PaketSearch", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.altpaketitems=response.body.data;
            console.log("MasterTurAltPaketList response :");
            console.log(response.body);
            this.loadingvmodel=false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel=false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.loadingvmodel=false;
        }
      );
    },
    vazgecPakettenPaket(){
      this.pakettenPaketKopyalaDialog = false;
    },

     
      deletemastertur: deletemastertur,
      masterturekle: masterturekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      tarihim,
      snackbarcomp
    },
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
    
  }

  function Kaydet() {
  if (this.eklenecektarih==null)
  {
    return;
  }
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));
  let paramscopy = {
    MasterTurId: this.selectedmasterid,
    Tarih: this.eklenecektarih,
    tumSirketler: false,
    sayfaAdi: null,
  };
  tool.http_post(this, "PaketKopyala", paramscopy).then(
    (response) => {
      if (response.body.Status == true) {
        this.tmpalttur=response.body.data;
        var prmprogramlar={
                FiyatGruplari:[],
              };

        this.tmpalttur.Program.FiyatGruplari.forEach((value, index) => {
          var grup={Id:value.Id,FiyatGrubuId:value.FiyatGrubu.id,silinecek:"false",AltGruplar:[]};
          value.AltGruplar.forEach((valuealt,indexalt)=>{
         
            var altgrup={Id:valuealt.Id,AltGrupId:valuealt.AltGrup.id,Tarihler:[],
              SatisFiyat: {
                                TekKisiFiyati: valuealt.SatisFiyat.TekKisiFiyati,
                                SingleFarki: valuealt.SatisFiyat.SingleFarki,
                                UcuncuKisiFiyati: valuealt.SatisFiyat.UcuncuKisiFiyati,
                                CocukFiyati: valuealt.SatisFiyat.CocukFiyati,
                                BebekFiyati: valuealt.SatisFiyat.BebekFiyati,
                                ParaBirimi: valuealt.SatisFiyat.ParaBirimi,
                                Kur: valuealt.SatisFiyat.Kur,
                                Otel:valuealt.SatisFiyat.Otel,
                                OtelKategori:valuealt.SatisFiyat.OtelKategori,
                                PansiyonTipi:valuealt.SatisFiyat.PansiyonTipi
                            }
            };

            valuealt.Tarihler.forEach((valuetarih,indextarih)=>{
              var tarihprm = { Tarih: valuetarih.Tarih, Isler: [], Gun: valuetarih.Gun,Aciklama:valuetarih.Aciklama };
              valuetarih.Isler.forEach((valueis,indexis)=>{
               tarihprm.Isler.push ({Id:valueis.Id,IsTipi:valueis.IsTipi,silinecek:"false"});
              
            })
altgrup.Tarihler.push(tarihprm);

            })

            grup.AltGruplar.push(altgrup);
          }
        
        )
          prmprogramlar.FiyatGruplari.push( grup );
});

        let params = {
    MasterTurId: this.selectedmasterid,
    TurKodu: this.tmpalttur.TurKodu,
    TurAdi: this.tmpalttur.TurAdi,
    Notlar: this.tmpalttur.Notlar,
    Gece: this.tmpalttur.Gece,
    Gunduz: this.tmpalttur.Gunduz,
    Aktif: true,
    KategoriId: this.tmpalttur.Kategori.id,
    UrunGrubuId: this.tmpalttur.UrunGrubu.id,
    Kontenjan: this.tmpalttur.Kontenjan,
    Program: prmprogramlar,
    BaslangicTarihi:this.tmpalttur.BaslangicTarihi,
    BitisTarihi:this.tmpalttur.BitisTarihi,
    tumSirketler: false,
    sayfaAdi: null,
    VarisParkur:this.tmpalttur.VarisParkur,
        DonusParkur:this.tmpalttur.DonusParkur,
        BaslangicNoktasi:this.tmpalttur.BaslangicNoktasi,
        PaketResimler:this.tmpalttur.PaketResimler
  };
 
  tool.api_file_post2(this, "Coper/PaketInsert", [], params).then(
    (response) => {
      if (response.body.Status == true) {
        this.insertid=response.body.data.Id;
        console.log("PaketInsertControl response :");
        console.log(response.body.data);
        var url = '#/pakettur/turaltpaketislem/islem?id=' +  this.insertid;
        window.open(url, '_self')
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
    }
  ); 
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
    }
  );
       
  console.log("PaketKopyala response :");
  console.log(this.tmpalttur);
 

 

  }
  function masterturekle() {
    this.dialog = true
    this.MasterTur = {}
    this.dialog_baslik = 'Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()
  }

  function beforeMount() {

  }

  function deletemastertur() {
    if (window.confirm('Seçili Turu silmek istediğinizden emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    }
  }

  function guncelle() {
   
  }
</script>

<style>

</style>